import { useParams } from "react-router-dom";
import ConnectAccount from "./components/ConnectAccount";
import { marketsDictionary } from "../../_app/consts";

const ConnectAccountPage = () => {
  const params = useParams<{ market: string }>();

  return (
    <>
      {params.market && (
        <ConnectAccount
          market={{
            name: marketsDictionary[params.market].name,
            displayedName: marketsDictionary[params.market].displayedName,
          }}
        />
      )}
    </>
  );
};

export default ConnectAccountPage;
